module.exports = __webpack_public_path__ + "img/f-pt.71bc17ac.png";